angular
    .module("app")
    .controller("richiestaVolturaCtrl", function () {

    });